export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13022.0b52c8d6.jpg";